var React = require('react');

function MoneyBundle2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M-6-10h56v56H-6z","opacity":".5","key":0}),React.createElement("path",{"stroke":"#006AFF","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M9.099 24.4l-8.1-4.314m42.082 5.535l-14.854 8.994-8.947-4.774M9.1 20.106l-8.1-4.324m42.082 5.535L28.227 30.31l-8.933-4.772m14.61-14l9.34 5.047-15.018 9.085-8.933-4.75M9.1 15.466l-8.1-4.325 14.937-9.33 7.782 4.21m2.026-.872l9.767 5.372-16.197 10.052V31.44L9.099 26.068V15.283L25.744 5.15zM19 14.836l-1.3.797m7.95-4.871l-.82.503m-6.566 2.514c2.095 3.68 4.083 1.612 4.083 1.612 1.006-1.023-.168-2.144-.27-2.258l-.008-.007c-1.67-1.538-.053-2.507-.053-2.507 2.256-1.343 3.348 1.611 3.348 1.611","key":1})]));
}

MoneyBundle2.defaultProps = {"width":"45","height":"36","viewBox":"0 0 45 36"};

module.exports = MoneyBundle2;

MoneyBundle2.default = MoneyBundle2;
